import { useMemoizedFn } from 'ahooks'
import { Select, SelectProps, Tooltip } from 'antd'

import { pick } from '@eastcoal/common/utils/object'

import { useBlockType } from '@eastcoal/editor/hooks/useBlockType'
import { useRichEditorStore } from '@eastcoal/editor/Store/hooks/useStore'
import { useBaseStyles } from '@eastcoal/editor/themes/base/style'

export const BlockTypeSelect = () => {
  const { blockTypeList, blockTypeShortcuts } = useRichEditorStore(state =>
    pick(state, ['blockTypeList', 'blockTypeShortcuts'])
  )
  const [blockType, setBlockType] = useBlockType()

  const editorStyles = useBaseStyles()

  const optionRender: SelectProps['optionRender'] = useMemoizedFn(
    ({ value, label, data }) => {
      const HtmlTag = data.tag || value
      const labelNode = (
        <HtmlTag className={editorStyles[value]} style={{ margin: 0 }}>
          {label}
        </HtmlTag>
      )
      return (
        <Tooltip placement='right' title={blockTypeShortcuts[value]}>
          {labelNode}
        </Tooltip>
      )
    }
  )

  return (
    <Select
      optionRender={optionRender}
      options={blockTypeList}
      style={{ width: 100 }}
      value={blockType}
      onChange={item => {
        setBlockType({ type: item })
      }}
    />
  )
}
